// extracted by mini-css-extract-plugin
export default {"btn":"templateManagement_btn__hMX0n","input-service":"templateManagement_input-service__Tf0IX"};